export const cdLetters = ['A', 'B', 'C', 'E', 'F', 'G', 'H', 'J'];
export const hudNumbers = ['700', '800', '900', '1000', '1100', '1200', '1300'];